import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';

const ModalConfirm = ({
  message,
  onClose,
  onConfirm,
  onConfirmLabel,
  dialogTitle,
}) => (
    <Dialog
      maxWidth="md"
      fullWidth
      open
      onBackdropClick={onClose}
    >
      <DialogTitle>{dialogTitle || 'Warning!'}</DialogTitle>
      <DialogContent>
        {message}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => { onConfirm(); onClose(); }}>{onConfirmLabel || 'OK'}</Button>
      </DialogActions>
    </Dialog>
  );

ModalConfirm.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalConfirm;
